import { render } from "./BookMarkButton.vue?vue&type=template&id=6bc63f13&scoped=true&ts=true"
import script from "./BookMarkButton.vue?vue&type=script&lang=ts"
export * from "./BookMarkButton.vue?vue&type=script&lang=ts"

import "./BookMarkButton.vue?vue&type=style&index=0&id=6bc63f13&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc63f13"]])

export default __exports__